import { API } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import ActivityForm from "components/activities/ActivityForm";
import { createActivity } from "graphql/mutations";

const ActivityCreateForm = ({ maintenanceRoutineID, onSuccess }) => {
  const navigate = useNavigate();
  const activity = {
    name: "",
    type: "",
    description: "",
    abbreviation: "",
    unit: "",
    defaultValue: "",
    values: [],
  };

  async function onSubmit(valuesAct) {
    try {
      const {
        name,
        type,
        description,
        abbreviation,
        unit,
        defaultValue,
        values,
      } = valuesAct;

      await API.graphql({
        query: createActivity.replaceAll("__typename", ""),
        variables: {
          input: {
            name,
            type,
            description,
            abbreviation,
            unit,
            defaultValue,
            values: JSON.stringify(values),
            maintenanceRoutineID,
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/activities");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  return (
    <div>
      <ActivityForm onSubmit={onSubmit} initialValues={activity} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Actividad",
    successAdded: "Actividad agregada con éxito",
    responses: {},
  },
});

export default ActivityCreateForm;
